import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FullscreenStatus } from "@/components/layout/FullscreenStatus";
import { getProtectedRouteDecision, useAuthStore } from "@/stores/authStore";

export function ProtectedRoute() {
  const { t } = useTranslation();
  const location = useLocation();
  const authStatus = useAuthStore((state) => state.authStatus);
  const banStatus = useAuthStore((state) => state.banStatus);
  const isHydrated = useAuthStore((state) => state.isHydrated);
  const user = useAuthStore((state) => state.user);

  const decision = getProtectedRouteDecision({ authStatus, banStatus, isHydrated });

  if (decision === "pending") {
    return <FullscreenStatus title={t("common.loading")} />;
  }

  if (decision === "verify") {
    return (
      <Navigate
        to="/verify-email-pending"
        replace
        state={{ email: user?.email, from: location.pathname }}
      />
    );
  }

  if (decision === "login") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
